<footer>
  <div class="footerWingParent">
    <div class="container">
      <div class="footerWingChild"></div>
    </div>
  </div>
  <div class="footer">
    <div class="py-4">
      <div class="container">
        <div markdown [data]="content"></div>
      </div>
    </div>
  </div>
</footer>